import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/shared-module/seguridad/services/auth.guard';
import { AplicacionComponent } from './views/baja_usuario/aplicacion/aplicacion.component';
import { AplicacionUsuarioComponent } from './views/baja_usuario/aplicacion-usuario/aplicacion-usuario.component';
import { DataLdapComponent } from './views/data-ldap/data-ldap.component';
import { GestionAliasComponent } from './views/gestion-alias/gestion-alias.component';
import { DatosUbitsComponent } from './views/datos-ubits/datos-ubits.component';
import { CrearUsuarioUbitsComponent } from './views/crear-usuario-ubits/crear-usuario-ubits.component';

const SeguridadDARoutes: Routes = [
    { path: 'da/baja_user/aplicacion',      component: AplicacionComponent, canActivate: [AuthGuard]},//ROLE_ADECCO_FABRIL
    { path: 'da/baja_user/aplicacion_user', component: AplicacionUsuarioComponent, canActivate: [AuthGuard]},//ROLE_ADECCO_FABRIL
    { path: 'da/baja_user/data_ldap',       component: DataLdapComponent, canActivate: [AuthGuard]},//ROLE_ADECCO_FABRIL

    { path: 'seguridad/gestion_alias',      component: GestionAliasComponent, canActivate: [AuthGuard]},         //ROLE_ADECCO_FABRIL
    { path: 'seguridad/datos_ubits',        component: DatosUbitsComponent, canActivate: [AuthGuard]},             //ROLE_ADECCO_FABRIL
    { path: 'seguridad/crear_usuario_all', component: CrearUsuarioUbitsComponent, canActivate: [AuthGuard]},  //ROLE_ADECCO_FABRIL
  ];
  
  @NgModule({
    imports: [RouterModule.forChild(SeguridadDARoutes)],
    exports: [RouterModule]
  })
  export class SeguridadDARouteModule {}
